export enum DragActions {
  MOVE = 'MOVE',
  SCALE = 'SCALE',
  NO_MOVEMENT = 'NO_MOVEMENT',
}

export enum Color {
  RED = 'red',
  ORANGE = 'orange',
  YELLOW = 'yellow',
  OLIVE = 'olive',
  GREEN = 'green',
  TEAL = 'teal',
  BLUE = 'blue',
  VIOLOET = 'violet',
  PURPLE = 'purple',
  BROWN = 'brown',
  GREY = 'grey',
  BLACK = 'black',
}

export enum AttachmentTypes {
  IMAGE = 'image',
  DRAWING = 'drawing',
  TEXT = 'text',
  CIRCLE = 'circle',
  RECTANGLE ='rectangle',
  TRIANGLE = 'triangle',
  ELLIPSE = 'ellipse',
  LINE ='line',
  SIGN ='sign'
}

export enum TextMode {
  INSERT = 'insert',
  COMMAND = 'command',
}
